export default __webpack_public_path__ + "assets/images/9f21095a7a65ce582b194b809b7d36d8.svg";